/**
 * Aplica un orden nuevo, igual que los endpoints de reordenar: cada ítem de `ids`
 * toma su posición como `orden`. Los demás ítems conservan el suyo. Devuelve los
 * ítems ordenados por `orden`.
 */
export const aplicarOrden = <T extends { id: string; orden?: number }>(
  items: T[],
  ids: string[]
): T[] => {
  const posiciones = new Map(ids.map((id, indice) => [id, indice]));

  return items
    .map((item) => {
      const orden = posiciones.get(item.id);
      return orden === undefined ? item : { ...item, orden };
    })
    .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));
};
